import React from 'react';

const SvgArrowBack = () => (
  <svg viewBox="0 0 20 20" width="1em" height="1em">
    <path d="M10.7 7.7h6.5v4.6h-6.5v4.3l-8-6.6 8-6.6v4.3z" fill="currentColor" />
  </svg>
);

export default SvgArrowBack;
